module.exports = __webpack_public_path__ + "img/change-photo-show.30eed1b1.svg";